import { Link } from 'react-router-dom';

export default function ArticleSection() {
  const articles = [
    {
      slug: '/kakobuy-spreadsheet-guide',
      title: 'Complete Kakobuy Spreadsheet Guide 2026',
      date: 'July 9, 2026',
      tag: 'New',
      imageUrl: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20shopping%20list%20next%20to%20smartphone%20showing%20product%20grid%2C%20coffee%20cup%20and%20eyeglasses%20on%20warm%20wooden%20desk%2C%20morning%20sunlight%2C%20cozy%20organized%20workspace%2C%20minimalist%20editorial%20style&width=600&height=400&seq=article-guide-cover-v3&orientation=landscape',
      imageAlt: 'Complete Kakobuy Spreadsheet Guide',
    },
    {
      slug: '/kakobuy-vs-competitors',
      title: 'Kakobuy vs CSSBuy vs Superbuy vs Oopbuy',
      date: 'July 9, 2026',
      tag: 'Hot',
      imageUrl: 'https://readdy.ai/api/search-image?query=Four%20smartphones%20side%20by%20side%20each%20displaying%20different%20shopping%20app%20interfaces%20on%20wooden%20table%2C%20overhead%20flat%20lay%2C%20soft%20natural%20lighting%2C%20comparison%20concept%2C%20clean%20editorial%20style%2C%20minimal%20composition&width=600&height=400&seq=article-compare-cover-v3&orientation=landscape',
      imageAlt: 'Kakobuy vs Competitors Comparison',
    },
    {
      slug: '/kakobuy-spreadsheet-guide',
      title: 'How To Find The Best Kakobuy Finds',
      date: 'July 7, 2026',
      imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20assortment%20of%20fashion%20accessories%20scattered%20on%20white%20marble%20surface%2C%20sunglasses%20watch%20belt%20wallet%2C%20bright%20natural%20daylight%2C%20editorial%20flat%20lay%20with%20vibrant%20pops%20of%20color%2C%20clean%20modern%20composition&width=600&height=400&seq=article-finds-cover-v3&orientation=landscape',
      imageAlt: 'Best Kakobuy Finds Guide',
    },
    {
      slug: '/kakobuy-spreadsheet-guide',
      title: 'Kakobuy Spreadsheet Safety & Shopping Tips',
      date: 'July 6, 2026',
      imageUrl: 'https://readdy.ai/api/search-image?query=Shopping%20cart%20icon%20with%20verified%20checkmark%20badge%20on%20minimal%20cream%20background%2C%20shield%20symbol%20subtle%20alongside%2C%20warm%20natural%20lighting%2C%20trustworthy%20editorial%20photography%2C%20clean%20professional%20aesthetic&width=600&height=400&seq=article-safety-cover-v3&orientation=landscape',
      imageAlt: 'Kakobuy Shopping Safety Guide',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950">
            Fresh Guides &amp; Tutorials
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            Expert articles to help you master the kakobuy spreadsheet and shop like a pro.
          </p>
        </div>

        {/* Article Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {articles.map((article, idx) => (
            <Link
              key={idx}
              to={article.slug}
              className="group block bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors duration-200"
            >
              {/* Image */}
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {article.tag && (
                  <span className={`absolute top-3 left-3 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-md ${article.tag === 'Hot' ? 'bg-accent-500' : 'bg-primary-500'}`}>
                    {article.tag}
                  </span>
                )}
              </div>
              {/* Content */}
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug mb-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500">{article.date}</p>
              </div>
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 text-center">
          <Link
            to="/kakobuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-primary-500 text-sm font-semibold hover:text-primary-600 transition-colors cursor-pointer"
          >
            View All Articles
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-base"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}